import { CarBrandModel } from "@/types/api"
import { baseApi } from "./baseApi"

export const carBrandsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCarBrands: builder.query<CarBrandModel[], void>({
      query: () => `CarBrands`,
      keepUnusedDataFor: 60 * 60 * 1000, // 1 hour
    }),
  }),
})

export const { useGetCarBrandsQuery } = carBrandsApi